<template>
  <div>
    <!-- <v-btn to="/">메인으로?</v-btn> -->
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
  async created() {
    let replacePath = '/signin'
    const { token, error, message } = this.$route.query

    if (error || message) {
      await this.$swal.basic.error({
        title: '로그인 실패',
        text: message,
      })
    } else if (token) {
      await this.signinSuccess({
        accessToken: token,
        refreshToken: token,
      })
      let redirectUri = this.$cookies.get('redirectUri')
      if (!redirectUri) {
        redirectUri = '/'
      }
      this.$cookies.remove('redirectUri')
      replacePath = redirectUri
    }
    await this.$router.replace(replacePath)
  },
  methods: {
    ...mapActions('auth', ['signinSuccess', 'signinKakaoCode']),
  },
}
</script>
